import { IconManager } from '@speeki/icons';

import {
    InlineNoticeVariant,
    NoticeIcon,
    NoticeText,
    NoticeWrapper,
} from './InlineNotice.styled';

interface InlineNoticeProps {
    /**
     * `role="alert"` for messages the reporter must not miss (a failed code, a
     * disclosure warning); left off for purely descriptive notices so screen readers
     * are not interrupted.
     */
    assertive?: boolean;
    children: React.ReactNode;
    className?: string;
    testId?: string;
    variant?: InlineNoticeVariant;
}

export const InlineNotice = ({
    assertive = false,
    children,
    className,
    testId,
    variant = 'info',
}: InlineNoticeProps) => (
    <NoticeWrapper
        className={className}
        data-testid={testId}
        role={assertive ? 'alert' : undefined}
        variant={variant}
    >
        <NoticeIcon variant={variant}>
            <IconManager
                icon={variant === 'success' ? 'SvgTickRounded' : 'SvgAlert'}
                size={14}
            />
        </NoticeIcon>
        <NoticeText>{children}</NoticeText>
    </NoticeWrapper>
);
